import React from "react";

function Carousel() {
  return (
    <div>
      <div
        id="carouselExampleInterval"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <img
              height="auto"
              width="auto"
              src="https://chessmatemon.com/images/c1.webp"
              className="d-block w-100"
              alt="..."
              style={{ height: "48vh" }}
            />
          </div>
          <div className="carousel-item" data-bs-interval="5000">
            <img
              height="auto"
              width="auto"
              src="https://chessmatemon.com/images/c9.webp"
              className="d-block w-100"
              alt="..."
              style={{ height: "48vh" }}
            />
          </div>
          <div className="carousel-item" data-bs-interval="2000">
            <img
              height="auto"
              width="auto"
              src="https://chessmatemon.com/images/c0.webp"
              className="d-block w-100"
              alt="..."
              style={{ height: "48vh" }}
            />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleInterval"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default Carousel;
